"use strict";

import { gsap } from "gsap";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import React from "react";
import { createRoot } from "react-dom/client";
import ThemeWidget from "./react/ThemeWidget";

import headerScrolling from "./scripts/headerScrolling";
import mobileMenu from "./scripts/mobileMenu";
import inputSelect from "./scripts/inputSelect";
import parallax from "./scripts/parallax";
import accordion from "./scripts/accordion";
import gsapAnimations from "./scripts/gsapAnimations";
import inadimplencia from "./scripts/slider/inadimplencia";
import sliderEstrategia from "./scripts/slider/estrategia";
import vozSlider from "./scripts/slider/voz";
import newsBlog from "./scripts/slider/newsBlog";
import sliderAdimplencia from "./scripts/slider/adimplencia";
import sliderModelo from "./scripts/slider/modelo";
import sliderTestimonials from "./scripts/slider/testimonials";
import pessoasAccordion from "./scripts/pessoasAccordion";
import blogContent from "./scripts/blogContent";
import quemConfia from "./scripts/slider/quemConfia";
import ecoGanho from "./scripts/slider/ecoGanho";
import simuladorHero from "./scripts/simulador/simuladorHero";
import simuladorResultados from "./scripts/simulador/simuladorResultados";

window.gsap = gsap;

headerScrolling();
mobileMenu();
inputSelect();
parallax();
accordion();
gsapAnimations();
inadimplencia();
sliderEstrategia();
vozSlider();
newsBlog();
sliderAdimplencia();
sliderModelo();
sliderTestimonials();
pessoasAccordion();
blogContent();
quemConfia();
ecoGanho();

simuladorHero();
simuladorResultados();
/*
const reactRoot = document.getElementById("theme-react-root");

if (reactRoot) {
    const { title, description } = reactRoot.dataset;
    const root = createRoot(reactRoot);

    root.render(
        <ThemeWidget
            title={title || "Integração com React"}
            description={
                description ||
                "Este bloco é renderizado pelo React e pode ser evoluído com componentes."
            }
        />
    );
}*/
